<template>
    <svg :class="`stroke-${color} cursor-pointer`" :width="width" :height="height" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         fill="none"
         viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
        <g>
	        <path class="wave" d="M11,7c3.7,0,3.8,4,7.5,4s3.8-4,7.5-4" stroke-miterlimit="10"/>
            <path class="wave" d="M4,17c3.7,0,3.8-4,7.5-4s3.8,4,7.5,4" stroke-miterlimit="10"/>
            <path class="wave" d="M11,19c3.7,0,3.8,4,7.5,4s3.8-4,7.5-4" stroke-miterlimit="10"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IcFlux",
    props: {
        width: {
            type: Number,
            default: 30
        },
        height: {
            type: Number,
            default: 30
        },
        color: {
            type: String,
            default: 'black'
        },
    },
}
</script>

<style scoped>

.wave {
    stroke-dasharray: 50px 10px;
    stroke-dashoffset: -30px;
    transition: all 0.5s;
}

svg:hover .wave,
svg:focus .wave,
svg:active .wave {
    cursor: pointer;
    stroke-dashoffset: 0;
}

</style>
